import axios from '@/utils/axios';
import { ReviewPayload } from '@/models/review-payload';
import { plainToClass } from 'class-transformer';
import { ReviewResponse } from '@/models/review-response';

export class ReviewsService {
  static sendReview(payload: ReviewPayload): Promise<ReviewResponse> {
    return axios.post('reviews/', payload).then(({ data }) => {
      return plainToClass(ReviewResponse, data);
    });
  }

  static sendOpinion(comment: string, id: string) {
    const payload: { [key: string]: string } = {
      comment,
    };
    return axios.patch(`reviews/${id}/`, payload);
  }

  static setGoogleMapsClicked(id: string) {
    const payload: { [key: string]: boolean } = {
      google_maps_clicked: true,
    };
    return axios.patch(`reviews/${id}/`, payload);
  }
}
